import { Component, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { DesyAngularModule } from 'desy-angular';

interface Info {
  icon: string;
  style?: string;
  tooltip: string;
}

@Component({
  selector: 'app-description',
  imports: [TooltipModule, DesyAngularModule],
  templateUrl: './description.component.html',
})
export class DescriptionComponent {
  @Input() title!: string;
  @Input() description!: string;
  @Input() linkText!: string;
  @Input() linkReference!: string;
  @Input() externalLink!: string;
  @Input() icons: Info[] = [];
  @Input() action?: () => void;
  @Input() subtitle!: string;
}
